<sim-basic-material-dialog
	(closeClicked)="close()"
	[finished]="finished"
	[matDialogData]="data"
	[rect]="rect"
	[headerText]="T.CHANGE_CHECKLIST_TYPE_DIALOG_HEADER | translate"
>
	<ng-container titleIcon>
		<mat-icon fontSet="fad" fontIcon="fa-exchange" inline />
	</ng-container>

	<ng-container dialogContent>
		@if (data) {
			<mat-form-field color="accent" class="full-width-form">
				<mat-label>{{ T.ASSESSABLE_ITEM_CHOOSE_TYPE | translate }}</mat-label>
				<mat-select [(value)]="selectedChecklistType">
					<mat-option [value]="ChecklistType.SingleChoiceOption">
						<mat-icon fontSet="fad" fontIcon="fa-check" inline />
						{{ T.CHANGE_TYPE_OF_CHECKLIST_ITEM_SINGLE_CHOICE_OPTION | translate }}
					</mat-option>
					<mat-option [value]="ChecklistType.MultipleChoiceOption">
						<mat-icon fontSet="fad" fontIcon="fa-check-double" inline />
						{{ T.CHANGE_TYPE_OF_CHECKLIST_ITEM_MULTIPLE_CHOICE_OPTION | translate }}
					</mat-option>
					<mat-option [value]="ChecklistType.FreeAnswerOption">
						<mat-icon fontSet="fad" fontIcon="fa-font-case" inline />
						{{ T.CHANGE_TYPE_OF_CHECKLIST_ITEM_FREE_ANSWER_QUESTION | translate }}
					</mat-option>
					<mat-option [value]="ChecklistType.ThreeStarOption">
						<mat-icon fontSet="fad" fontIcon="fa-star-half" inline />
						{{ T.CHANGE_TYPE_OF_CHECKLIST_ITEM_THREE_STAR_OPTION | translate }}
					</mat-option>
					<mat-option [value]="ChecklistType.YesNoOption">
						<mat-icon fontSet="fad" fontIcon="fa-toggle-on" inline />
						{{ T.CHANGE_TYPE_OF_CHECKLIST_ITEM_YES_NO_OPTION | translate }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		}

		@if (
			(startingChecklistType === ChecklistType.MultipleChoiceOption || startingChecklistType === ChecklistType.SingleChoiceOption) &&
			(selectedChecklistType === ChecklistType.MultipleChoiceOption || selectedChecklistType === ChecklistType.SingleChoiceOption)
		) {
			<div class="migrateExistingOptions">
				<mat-checkbox class="example-margin" [(ngModel)]="migrateExistingOptions">
					{{ T.CHANGE_TYPE_OF_CHECKLIST_ITEM_MIGRATE_EXISTING | translate }}</mat-checkbox
				>
			</div>
		}
	</ng-container>

	<ng-container actions>
		<button mat-raised-button color="accent" [disabled]="startingChecklistType === selectedChecklistType" (click)="updateType()">
			{{ T.CHANGE_TYPE_OF_CHECKLIST_ITEM_UPDATE_TYPE | translate }}
		</button>
	</ng-container>
</sim-basic-material-dialog>
